
export class Fukidashi {
  constructor() {
    const img = new Image()
    img.src = 'https://storage.googleapis.com/wcam-27caf.appspot.com/public/fukidashi.png?a=1'
    // img.src = './static/fukidashi.png'
    img.onload = () => { this.img = img }
  }

  draw(ctx, pos, size, text) {
    if(!this.img) return
    const w = 240 * (size/100)
    ctx.drawImage(this.img, 0, 0, 240, 240, pos.x, pos.y - 0.5*w, w, w)
    ctx.font = `${size}px 'Noto Sans JP', sans-serif`
    ctx.fillStyle = 'black'
    ctx.fillText(text, pos.x + 0.5*size+20,  pos.y + 0.5*size-20)
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Fukidashi.js